import React, { useState, useEffect, useMemo } from 'react';
import { convertiDataComputer2Umano } from './funzioni.js'
import SelezionaData from './SelezionaData';
import Clessidra from '../Pagine/Clessidra'
import Tendina2 from './Tendina2';
import stile from './stile.module.css';

import { haPersonalizzazione } from '../funzioni.js';

function PrenotazioniElenco(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "impostaFiltri": 2,
        "creaReport": 3,
        "visualizzaReport": 4
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [elencoNomiCorsi, setElencoNomiCorsi] = useState([]);
    const [elencoIDCorsi, setElencoIDCorsi] = useState([]);  
    const [dataInizio, setDataInizio] = useState(new Date().toISOString().split('T')[0]);
    const [idCorsoSelezionato, setIDCorsoSelezionato] = useState(0);
    const [datiReport, setDatiReport] = useState([]);

    
    var oggetto = "corso";
    if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_campo")) oggetto = "campo";

    function ReportRaggruppato({ datiReport }) {
        const [gruppiEspansi, setGruppiEspansi] = useState({});

        // Raggruppamento con useMemo per efficienza
        const gruppi = useMemo(() => {
            const mappa = {};

            datiReport.forEach(el => {
                // Esclude le prenotazioni annullate
                if (Number(el.STATO) === 2) return;

                const chiave = `${el.DESCRIZIONE}___${el.DATA_INIZIO}___${el.DATA_FINE}`;

                if (!mappa[chiave]) {
                    mappa[chiave] = {
                        descrizione: el.DESCRIZIONE,
                        dataInizio: el.DATA_INIZIO,
                        dataFine: el.DATA_FINE,
                        elementi: [],
                        listaAttesa: [],
                    };
                }

                if (Number(el.STATO) === -1) {
                    mappa[chiave].listaAttesa.push(el);
                } else {
                    mappa[chiave].elementi.push(el);
                }
            });

            return Object.values(mappa).sort((a, b) => {
                // Prima ordina per DATA_INIZIO crescente. Se due DATA_INIZIO sono uguali, ordina per DESCRIZIONE in ordine alfabetico.
                const diff = new Date(a.dataInizio) - new Date(b.dataInizio);
                if (diff !== 0) return diff;
                return a.descrizione.localeCompare(b.descrizione);
            });
        }, [datiReport]);

        // Funzione per formattare la data
        const formattaData = (dataIso) => {
            return dataIso.split("T")[1]; // "2025-04-09T00:00" → "00:00"
        };

        const toggleGruppo = (chiave) => {
            setGruppiEspansi(prev => ({
            ...prev,
            [chiave]: !prev[chiave]
            }));
        };

        return (
            <>
            {gruppi.map((gruppo, indice) => {
                const chiave = `${gruppo.descrizione}___${gruppo.dataInizio}___${gruppo.dataFine}`;
                return (
                <div key={indice} style={{ marginBottom: "1em" }}>
                    <div
                    onClick={() => {if (props.identitaSelezionata.livello!=="base") toggleGruppo(chiave)}}
                    style={{ cursor: props.identitaSelezionata.livello==="base"?"":"pointer", fontWeight: "bold", background: "#ffffff", border: "1px solid #909090", borderRadius: 20, padding: "0.5em" }}
                    >
                    {formattaData(gruppo.dataInizio)} → {formattaData(gruppo.dataFine)}: {gruppo.descrizione}: {gruppo.elementi.length}
                    &nbsp;
                    {gruppo.elementi.length} {gruppo.elementi.length==1?"prenotazione":"prenotazioni"}
                    {gruppo.listaAttesa.length > 0 &&
                        <> ({gruppo.listaAttesa.length} in lista attesa)</>
                    }
                    </div>
                    {gruppiEspansi[chiave] && (
                    <div style={{ paddingLeft: "1em", marginTop: "0.5em" }}>
                        {gruppo.elementi.map((el, idx) => (
                        <div key={idx} style={{marginTop:1, backgroundColor:"#C0E0E0", paddingLeft:5, paddingBottom: 3, paddingRight:3}}>
                            {el.COGNOME} {el.NOME} {el.NUMERO_TESSERA!="" && <> ({el.NUMERO_TESSERA})
                            {el.NOTE!="" && <div style={{marginLeft:5, paddingLeft: 5, backgroundColor:"#ffffff", fontSize:14}}>{el.NOTE}</div>}</>}
                        </div>
                        ))}
                        {gruppo.listaAttesa.length > 0 &&
                            <>
                                <div style={{marginTop:8, fontWeight:"bold"}}>
                                    Lista di attesa
                                </div>

                                {gruppo.listaAttesa.map((el, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            marginTop:1,
                                            backgroundColor:"#f2f1be",
                                            paddingLeft:5,
                                            paddingBottom:3,
                                            paddingRight:3
                                        }}
                                    >
                                        {el.COGNOME} {el.NOME}
                                        {el.NUMERO_TESSERA!="" && <> ({el.NUMERO_TESSERA})</>}
                                    </div>
                                ))}
                            </>
                        }                        
                    </div>
                    )}
                </div>
                );
            })}
            </>
        );
    }

    function ottieniElencoCorsi() {
        //console.log("ottieniElencoCorsi: inizio");
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op:"elencoCorsi", emak: props.emak, sessionId: props.sessionId })
        };
        fetch(props.UrlBackend, requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreRitorno) => {
            if (valoreRitorno.verifvers===0) {
              // necessario aggiornare la app
              props.callbackAggiornaApp();
              return;
            }
            if (valoreRitorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
            if (valoreRitorno.risultatoOperazione === 1) {
              let elencoID = [];
              let elencoNomi = [];
              for (let n=0; n<valoreRitorno.risultatoRitorno.length; n++) {
                elencoID[n] = valoreRitorno.risultatoRitorno[n].ID;
                elencoNomi[n] = valoreRitorno.risultatoRitorno[n].NOME;
              }
              setElencoIDCorsi(elencoID);
              setElencoNomiCorsi(elencoNomi);
              setPagina(PAGINE.impostaFiltri);
              return;
            }              
          },
          (error) => { 
            props.callback(props.PAGINECLIENTI.login);
            return;
          }
        )
        .catch(function(error) {
          props.callback(props.PAGINECLIENTI.login);
          return;
        });
    }

    function ottieniElencoPrenotazioni(){
        // l'operazione consentirebbe anche di filtrare per idPersona
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"reportElencoPrenotazioni",
            emak: props.emak,
            idCorso:idCorsoSelezionato,
            dataInizio:dataInizio,
            dataFine:dataInizio,
            sessionId:props.sessionId})
        };
    
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione===2) { props.callback(props.PAGINECLIENTI.login); return; }
                if(valoreDiRitorno.risultatoOperazione===1){
                    console.log(valoreDiRitorno)
                    setDatiReport(valoreDiRitorno.risultatoRitorno);
                    setPagina(PAGINE.visualizzaReport);
                }
            },
            (error) => {props.callback(props.PAGINECLIENTI.login);}
            );
    }

    useEffect(() => {
        ottieniElencoCorsi();
    }, [])
    
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])  

    if (pagina === PAGINE.caricamentoDati || pagina === PAGINE.creaReport) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.impostaFiltri) {
        return (
            <div className={stile.contenitorePrincipale} style={{flex:1, padding:10}}>
                <div className={stile.finestraDialogo}>
    
                    <div style={{display:'flex', flexDirection: 'row'}}>
                        <div style={{flex:2}}>
                            <div>Prenotazioni del giorno</div>
                            <div style={{display:'flex', flexDirection: 'row'}}>
                                <div style={{ flexGrow: 1 }}>
                                    <SelezionaData data={dataInizio} setData={setDataInizio} style={{width:"100%"}} className={stile.casellaInputGenerica} />
                                </div>
                            </div>
                        </div>                       
                    </div>                    
    
                    <br/>

                    <div>Per il {oggetto}</div>

                    <Tendina2
                        className={stile.genericaDropdown}
                        options={['tutti', ...elencoNomiCorsi]}                        
                        onSelect={(t) => {
                            if (t > 0) {                                
                                setIDCorsoSelezionato(elencoIDCorsi[t-1]);
                            } else {
                                setIDCorsoSelezionato(0);
                            }
                        }}
                    />

                    <br/>
    
                    {/* Barra inferiore con i pulsanti */}
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "auto" }}>
    
                        <div className={[stile.baRossoSoft, stile.baNormale].join(" ")} onClick={() => { props.callback(props.PAGINECLIENTI.prenotazioniMenu) }}>
                            <div className={stile.spazioIconaPiccola}>
                                <img className={stile.iconaPiccolaQuadrata} src={require('./annullabianco.png')} />
                            </div>
                            Annulla
                        </div>
    
                        <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} onClick={() => {setPagina(PAGINE.creaReport); ottieniElencoPrenotazioni();}}>
                            <div className={stile.spazioIconaPiccola}>
                                <img className={stile.iconaPiccolaQuadrata} src={require('./okbianco.png')} />
                            </div>
                            Elenca Prenotazioni
                        </div>
                    </div>
                </div>
    
            </div>
        );
    }

    if (pagina === PAGINE.visualizzaReport) {
        return (
            <div className={stile.contenitorePrincipale} style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding:10 }}>
                <div className={stile.prenotazioniTitoloReport}>REPORT PRENOTAZIONI {convertiDataComputer2Umano(dataInizio,"")}</div>
                {datiReport.some(el => Number(el.STATO) !== 2) ?
                    <>
                        {props.identitaSelezionata.livello !== "base" && <div style={{paddingTop:5, paddingBottom:5, fontStyle:'italic'}}>clicca sul {oggetto} per l'elenco dei prenotati</div>}
                        <ReportRaggruppato datiReport={datiReport} />
                    </>
                :
                    <div style={{paddingTop:5, paddingBottom:5, fontStyle:'italic'}}>non ci sono prenotazioni</div>
                }
            </div>
        )
    }

    return (
        <div>Errore pagina non trovata (PrenotazioniElenco)</div>
    )
}

export default PrenotazioniElenco;
